import {useRef, useEffect, DependencyList, EffectCallback} from 'react';

// Like useEffect but doesn't run effect on first render,
// only after the deps have changed
export const useEffectAfterMount = (
    effect: EffectCallback,
    deps: DependencyList
) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            effect();
        } else {
            didMount.current = true;
        }
    }, deps);
};
